/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AuthIssuedCouponSearchResponseDto } from '../models/auth-issued-coupon-search-response-dto';
import { autoIssuedCouponControllerCreate } from '../fn/auto-issued-coupon/auto-issued-coupon-controller-create';
import { AutoIssuedCouponControllerCreate$Params } from '../fn/auto-issued-coupon/auto-issued-coupon-controller-create';
import { autoIssuedCouponControllerCronTestBirthDate } from '../fn/auto-issued-coupon/auto-issued-coupon-controller-cron-test-birth-date';
import { AutoIssuedCouponControllerCronTestBirthDate$Params } from '../fn/auto-issued-coupon/auto-issued-coupon-controller-cron-test-birth-date';
import { autoIssuedCouponControllerCronTestSpecificDate } from '../fn/auto-issued-coupon/auto-issued-coupon-controller-cron-test-specific-date';
import { AutoIssuedCouponControllerCronTestSpecificDate$Params } from '../fn/auto-issued-coupon/auto-issued-coupon-controller-cron-test-specific-date';
import { autoIssuedCouponControllerDelete } from '../fn/auto-issued-coupon/auto-issued-coupon-controller-delete';
import { AutoIssuedCouponControllerDelete$Params } from '../fn/auto-issued-coupon/auto-issued-coupon-controller-delete';
import { autoIssuedCouponControllerFindById } from '../fn/auto-issued-coupon/auto-issued-coupon-controller-find-by-id';
import { AutoIssuedCouponControllerFindById$Params } from '../fn/auto-issued-coupon/auto-issued-coupon-controller-find-by-id';
import { autoIssuedCouponControllerSearch } from '../fn/auto-issued-coupon/auto-issued-coupon-controller-search';
import { AutoIssuedCouponControllerSearch$Params } from '../fn/auto-issued-coupon/auto-issued-coupon-controller-search';
import { autoIssuedCouponControllerStopToggle } from '../fn/auto-issued-coupon/auto-issued-coupon-controller-stop-toggle';
import { AutoIssuedCouponControllerStopToggle$Params } from '../fn/auto-issued-coupon/auto-issued-coupon-controller-stop-toggle';
import { AutoIssuedCouponDto } from '../models/auto-issued-coupon-dto';

@Injectable({ providedIn: 'root' })
export class AutoIssuedCouponService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `autoIssuedCouponControllerSearch()` */
  static readonly AutoIssuedCouponControllerSearchPath = '/api/auto-issued-coupon';

  /**
   * 자동 발행 쿠폰 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `autoIssuedCouponControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  autoIssuedCouponControllerSearch$Response(params: AutoIssuedCouponControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthIssuedCouponSearchResponseDto>> {
    return autoIssuedCouponControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * 자동 발행 쿠폰 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `autoIssuedCouponControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  autoIssuedCouponControllerSearch(params: AutoIssuedCouponControllerSearch$Params, context?: HttpContext): Observable<AuthIssuedCouponSearchResponseDto> {
    return this.autoIssuedCouponControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthIssuedCouponSearchResponseDto>): AuthIssuedCouponSearchResponseDto => r.body)
    );
  }

  /** Path part for operation `autoIssuedCouponControllerCreate()` */
  static readonly AutoIssuedCouponControllerCreatePath = '/api/auto-issued-coupon';

  /**
   * 자동 발행 쿠폰 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `autoIssuedCouponControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  autoIssuedCouponControllerCreate$Response(params: AutoIssuedCouponControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return autoIssuedCouponControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 자동 발행 쿠폰 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `autoIssuedCouponControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  autoIssuedCouponControllerCreate(params: AutoIssuedCouponControllerCreate$Params, context?: HttpContext): Observable<void> {
    return this.autoIssuedCouponControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `autoIssuedCouponControllerFindById()` */
  static readonly AutoIssuedCouponControllerFindByIdPath = '/api/auto-issued-coupon/{id}';

  /**
   * 자동 발행 쿠폰 상세 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `autoIssuedCouponControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  autoIssuedCouponControllerFindById$Response(params: AutoIssuedCouponControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<AutoIssuedCouponDto>> {
    return autoIssuedCouponControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 자동 발행 쿠폰 상세 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `autoIssuedCouponControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  autoIssuedCouponControllerFindById(params: AutoIssuedCouponControllerFindById$Params, context?: HttpContext): Observable<AutoIssuedCouponDto> {
    return this.autoIssuedCouponControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<AutoIssuedCouponDto>): AutoIssuedCouponDto => r.body)
    );
  }

  /** Path part for operation `autoIssuedCouponControllerDelete()` */
  static readonly AutoIssuedCouponControllerDeletePath = '/api/auto-issued-coupon/{id}';

  /**
   * 자동 발행 쿠폰 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `autoIssuedCouponControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  autoIssuedCouponControllerDelete$Response(params: AutoIssuedCouponControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return autoIssuedCouponControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 자동 발행 쿠폰 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `autoIssuedCouponControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  autoIssuedCouponControllerDelete(params: AutoIssuedCouponControllerDelete$Params, context?: HttpContext): Observable<void> {
    return this.autoIssuedCouponControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `autoIssuedCouponControllerCronTestSpecificDate()` */
  static readonly AutoIssuedCouponControllerCronTestSpecificDatePath = '/api/auto-issued-coupon/cron-test-specific-date';

  /**
   * 특정 날짜 쿠폰 발급 테스트.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `autoIssuedCouponControllerCronTestSpecificDate()` instead.
   *
   * This method doesn't expect any request body.
   */
  autoIssuedCouponControllerCronTestSpecificDate$Response(params?: AutoIssuedCouponControllerCronTestSpecificDate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return autoIssuedCouponControllerCronTestSpecificDate(this.http, this.rootUrl, params, context);
  }

  /**
   * 특정 날짜 쿠폰 발급 테스트.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `autoIssuedCouponControllerCronTestSpecificDate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  autoIssuedCouponControllerCronTestSpecificDate(params?: AutoIssuedCouponControllerCronTestSpecificDate$Params, context?: HttpContext): Observable<void> {
    return this.autoIssuedCouponControllerCronTestSpecificDate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `autoIssuedCouponControllerCronTestBirthDate()` */
  static readonly AutoIssuedCouponControllerCronTestBirthDatePath = '/api/auto-issued-coupon/cron-test-birth-date';

  /**
   * 생일 쿠폰 발급 테스트.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `autoIssuedCouponControllerCronTestBirthDate()` instead.
   *
   * This method doesn't expect any request body.
   */
  autoIssuedCouponControllerCronTestBirthDate$Response(params?: AutoIssuedCouponControllerCronTestBirthDate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return autoIssuedCouponControllerCronTestBirthDate(this.http, this.rootUrl, params, context);
  }

  /**
   * 생일 쿠폰 발급 테스트.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `autoIssuedCouponControllerCronTestBirthDate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  autoIssuedCouponControllerCronTestBirthDate(params?: AutoIssuedCouponControllerCronTestBirthDate$Params, context?: HttpContext): Observable<void> {
    return this.autoIssuedCouponControllerCronTestBirthDate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `autoIssuedCouponControllerStopToggle()` */
  static readonly AutoIssuedCouponControllerStopTogglePath = '/api/auto-issued-coupon/{id}/stop-toggle';

  /**
   * 자동 발행 쿠폰 발행 중지.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `autoIssuedCouponControllerStopToggle()` instead.
   *
   * This method doesn't expect any request body.
   */
  autoIssuedCouponControllerStopToggle$Response(params: AutoIssuedCouponControllerStopToggle$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return autoIssuedCouponControllerStopToggle(this.http, this.rootUrl, params, context);
  }

  /**
   * 자동 발행 쿠폰 발행 중지.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `autoIssuedCouponControllerStopToggle$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  autoIssuedCouponControllerStopToggle(params: AutoIssuedCouponControllerStopToggle$Params, context?: HttpContext): Observable<void> {
    return this.autoIssuedCouponControllerStopToggle$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
